import * as React from 'react';
import {
    Modal,
    Button,
    FormControl,
    FormGroup,
    Form,
    ControlLabel,
    Checkbox,
    HelpBlock,
    Tab,
    Nav,
    NavItem,
    Table,
    Row,
    Col
} from 'react-bootstrap';
import FormSelect from '../../../components/common/FormSelect';
import { Translate } from '../../../shared/LanguageService';
import FormValidationService from '../../../shared/form/FormValidationService';
import SelectPlanTemplate from '../SelectPlanTemplate';

interface IPlanSettings {
    roomSketcherKey: string;
    planFirmId: string;
    cubicasaExporterPlanFloorTemplateId: string;
    directDelivery: boolean;
    includeFreeFloorplansWithPhotoOrder: boolean;
    planTemplateId: string;
    planSketchInformation: string;
    planEditorInformation: string;
    roomSketcherFurnishLink: boolean;

    roomSketcher_2DPhoto_SingleJpeg: boolean;
    roomSketcher_2DPhoto_SingleLetterheadRelativeJpeg: boolean;
    roomSketcher_2DPhoto_SingleLetterheadRelativePdf: boolean;

    roomSketcher_2DSketch_SingleJpeg: boolean;
    roomSketcher_2DSketch_SingleLetterheadRelativeJpeg: boolean;
    roomSketcher_2DSketch_SingleLetterheadRelativePdf: boolean;

    roomSketcher_3DPhoto_SingleJpeg: boolean;
    roomSketcher_3DPhoto_SingleLetterheadRelativeJpeg: boolean;
    roomSketcher_3DPhoto_SingleLetterheadRelativePdf: boolean;

    overrideDefaultPlanTemplate: boolean;
}

interface IPlanSettingsProps {
    availablePlanFirms: any[];
    availablePlanTemplates: any[];
    onChange: (e: any) => void;
    brokerFirmPlanSettings: IPlanSettings;
    errors: any;
    defaultPlanTemplateId: string;
    availableExporterPlanTemplates: any[];
}

const BrokerFirmPlanSettings = (props: IPlanSettingsProps) => {
    return (
        <fieldset>
            <legend>{Translate('broker-firm/form/tab/plan-settings')}</legend>
            <Row>
                <Col md={6}>
                    <FormGroup>
                        <ControlLabel>
                            {Translate('broker-firm/form/plan-settings/plan-firm')}
                        </ControlLabel>
                        <FormSelect
                            name="brokerFirmPlanSettings.planFirmId"
                            value={
                                props.brokerFirmPlanSettings.planFirmId
                                    ? props.brokerFirmPlanSettings.planFirmId
                                    : ''
                            }
                            defaultTranslateKey={'broker-firm/form/plan-settings/plan-firm/default'}
                            onChange={props.onChange}
                        >
                            {props.availablePlanFirms.map((x: any) => (
                                <option value={x.id} key={x.id}>
                                    {x.name}
                                </option>
                            ))}
                        </FormSelect>
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <SelectPlanTemplate
                        onChange={props.onChange}
                        planTemplates={props.availablePlanTemplates}
                        planTemplateId={props.brokerFirmPlanSettings.planTemplateId}
                        planTemplateIdName={'brokerFirmPlanSettings.planTemplateId'}
                        defaultPlanTemplateId={props.defaultPlanTemplateId}
                        errors={props.errors}
                        overrideDefaultPlanTemplate={
                            props.brokerFirmPlanSettings.overrideDefaultPlanTemplate
                        }
                        overrideDefaultPlanTemplateName={
                            'brokerFirmPlanSettings.overrideDefaultPlanTemplate'
                        }
                    />
                </Col>
            </Row>
            <Row>
                <Col md={4}>
                    <FormGroup>
                        <ControlLabel>
                            {Translate('broker-firm/form/plan-settings/exporter-template')}
                        </ControlLabel>
                        <FormSelect
                            name="brokerFirmPlanSettings.cubicasaExporterPlanFloorTemplateId"
                            value={
                                props.brokerFirmPlanSettings.cubicasaExporterPlanFloorTemplateId
                                    ? props.brokerFirmPlanSettings.cubicasaExporterPlanFloorTemplateId
                                    : ''
                            }
                            defaultTranslateKey={
                                'broker-firm/form/plan-settings/exporter-template/default'
                            }
                            onChange={props.onChange}
                        >
                            {props.availableExporterPlanTemplates.map((x: any) => (
                                <option value={x.id} key={x.id}>
                                    {x.name}
                                </option>
                            ))}
                        </FormSelect>
                    </FormGroup>
                </Col>
                <Col md={3} className="no-label">
                    <FormGroup>
                        <Checkbox
                            name={'brokerFirmPlanSettings.directDelivery'}
                            checked={props.brokerFirmPlanSettings.directDelivery}
                            onChange={props.onChange}
                        >
                            {' '}
                            <span>
                                {Translate('broker-firm/form/plan-settings/direct-delivery')}
                            </span>
                        </Checkbox>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <FormGroup>
                        <ControlLabel>
                            {Translate('broker-firm/form/plan-sketcher-information')}
                        </ControlLabel>
                        <FormControl
                            componentClass="textarea"
                            name="brokerFirmPlanSettings.planSketchInformation"
                            value={
                                props.brokerFirmPlanSettings.planSketchInformation
                                    ? props.brokerFirmPlanSettings.planSketchInformation
                                    : ''
                            }
                            onChange={props.onChange}
                        />
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup>
                        <ControlLabel>
                            {Translate('broker-firm/form/plan-settings/plan-editor-information')}
                        </ControlLabel>
                        <FormControl
                            componentClass="textarea"
                            name="brokerFirmPlanSettings.planEditorInformation"
                            value={
                                props.brokerFirmPlanSettings.planEditorInformation
                                    ? props.brokerFirmPlanSettings.planEditorInformation
                                    : ''
                            }
                            onChange={props.onChange}
                        />
                    </FormGroup>
                </Col>
            </Row>

            <fieldset>
                <legend>{Translate('broker-firm/form/plan-settings/room-sketcher')}</legend>
                <FormGroup
                    validationState={FormValidationService.getValidationState(
                        props.errors['brokerFirmPlanSettings.RoomSketcherKey']
                    )}
                >
                    <ControlLabel>
                        {Translate('broker-firm/form/plan-settings/room-sketcher-key')}
                    </ControlLabel>
                    <FormControl
                        name="brokerFirmPlanSettings.roomSketcherKey"
                        value={
                            props.brokerFirmPlanSettings.roomSketcherKey
                                ? props.brokerFirmPlanSettings.roomSketcherKey
                                : ''
                        }
                        onChange={props.onChange}
                    />
                    <HelpBlock>{props.errors['brokerFirmPlanSettings.RoomSketcherKey']}</HelpBlock>
                </FormGroup>

                <FormGroup>
                    <Checkbox
                        name="brokerFirmPlanSettings.roomSketcherFurnishLink"
                        checked={
                            props.brokerFirmPlanSettings.roomSketcherFurnishLink &&
                            props.brokerFirmPlanSettings.roomSketcherKey
                                ? props.brokerFirmPlanSettings.roomSketcherFurnishLink
                                : false
                        }
                        disabled={!props.brokerFirmPlanSettings.roomSketcherKey}
                        onChange={props.onChange}
                    >
                        <span>
                            {Translate('broker-firm/form/plan-settings/room-sketcher-furnish-link')}
                        </span>
                    </Checkbox>
                </FormGroup>

                <Row>
                    <Col md={2}></Col>
                    <Col md={2}>
                        <ControlLabel>
                            {Translate('broker-firm/form/plan-settings/room-sketcher/jpeg')}
                        </ControlLabel>
                    </Col>
                    <Col md={2}>
                        <ControlLabel>
                            {Translate(
                                'broker-firm/form/plan-settings/room-sketcher/jpeg-letterhead'
                            )}
                        </ControlLabel>
                    </Col>
                    <Col md={2}>
                        <ControlLabel>
                            {Translate(
                                'broker-firm/form/plan-settings/room-sketcher/pdf-letterhead'
                            )}
                        </ControlLabel>
                    </Col>
                </Row>
                <Row>
                    <Col md={2}>
                        <ControlLabel>
                            {Translate('broker-firm/form/plan-settings/room-sketcher-2d-photo')}
                        </ControlLabel>
                    </Col>
                    <Col md={2}>
                        <Checkbox
                            name="brokerFirmPlanSettings.roomSketcher_2DPhoto_SingleJpeg"
                            checked={
                                props.brokerFirmPlanSettings.roomSketcher_2DPhoto_SingleJpeg &&
                                props.brokerFirmPlanSettings.roomSketcherKey
                                    ? props.brokerFirmPlanSettings.roomSketcher_2DPhoto_SingleJpeg
                                    : false
                            }
                            disabled={!props.brokerFirmPlanSettings.roomSketcherKey}
                            onChange={props.onChange}
                        >
                            <span></span>
                        </Checkbox>
                    </Col>
                    <Col md={2}>
                        <Checkbox
                            name="brokerFirmPlanSettings.roomSketcher_2DPhoto_SingleLetterheadRelativeJpeg"
                            checked={
                                props.brokerFirmPlanSettings
                                    .roomSketcher_2DPhoto_SingleLetterheadRelativeJpeg &&
                                props.brokerFirmPlanSettings.roomSketcherKey
                                    ? props.brokerFirmPlanSettings
                                          .roomSketcher_2DPhoto_SingleLetterheadRelativeJpeg
                                    : false
                            }
                            disabled={!props.brokerFirmPlanSettings.roomSketcherKey}
                            onChange={props.onChange}
                        >
                            <span></span>
                        </Checkbox>
                    </Col>
                    <Col md={2}>
                        <Checkbox
                            name="brokerFirmPlanSettings.roomSketcher_2DPhoto_SingleLetterheadRelativePdf"
                            checked={
                                props.brokerFirmPlanSettings
                                    .roomSketcher_2DPhoto_SingleLetterheadRelativePdf &&
                                props.brokerFirmPlanSettings.roomSketcherKey
                                    ? props.brokerFirmPlanSettings
                                          .roomSketcher_2DPhoto_SingleLetterheadRelativePdf
                                    : false
                            }
                            disabled={!props.brokerFirmPlanSettings.roomSketcherKey}
                            onChange={props.onChange}
                        >
                            <span></span>
                        </Checkbox>
                    </Col>
                </Row>
                <Row>
                    <Col md={2}>
                        <ControlLabel>
                            {Translate('broker-firm/form/plan-settings/room-sketcher-2d-sketch')}
                        </ControlLabel>
                    </Col>
                    <Col md={2}>
                        <Checkbox
                            name="brokerFirmPlanSettings.roomSketcher_2DSketch_SingleJpeg"
                            checked={
                                props.brokerFirmPlanSettings.roomSketcher_2DSketch_SingleJpeg &&
                                props.brokerFirmPlanSettings.roomSketcherKey
                                    ? props.brokerFirmPlanSettings.roomSketcher_2DSketch_SingleJpeg
                                    : false
                            }
                            disabled={!props.brokerFirmPlanSettings.roomSketcherKey}
                            onChange={props.onChange}
                        >
                            <span></span>
                        </Checkbox>
                    </Col>
                    <Col md={2}>
                        <Checkbox
                            name="brokerFirmPlanSettings.roomSketcher_2DSketch_SingleLetterheadRelativeJpeg"
                            checked={
                                props.brokerFirmPlanSettings
                                    .roomSketcher_2DSketch_SingleLetterheadRelativeJpeg &&
                                props.brokerFirmPlanSettings.roomSketcherKey
                                    ? props.brokerFirmPlanSettings
                                          .roomSketcher_2DSketch_SingleLetterheadRelativeJpeg
                                    : false
                            }
                            disabled={!props.brokerFirmPlanSettings.roomSketcherKey}
                            onChange={props.onChange}
                        >
                            <span></span>
                        </Checkbox>
                    </Col>
                    <Col md={2}>
                        <Checkbox
                            name="brokerFirmPlanSettings.roomSketcher_2DSketch_SingleLetterheadRelativePdf"
                            checked={
                                props.brokerFirmPlanSettings
                                    .roomSketcher_2DSketch_SingleLetterheadRelativePdf &&
                                props.brokerFirmPlanSettings.roomSketcherKey
                                    ? props.brokerFirmPlanSettings
                                          .roomSketcher_2DSketch_SingleLetterheadRelativePdf
                                    : false
                            }
                            disabled={!props.brokerFirmPlanSettings.roomSketcherKey}
                            onChange={props.onChange}
                        >
                            <span></span>
                        </Checkbox>
                    </Col>
                </Row>
                <Row>
                    <Col md={2}>
                        <ControlLabel>
                            {Translate('broker-firm/form/plan-settings/room-sketcher-3d-photo')}
                        </ControlLabel>
                    </Col>
                    <Col md={2}>
                        <Checkbox
                            name="brokerFirmPlanSettings.roomSketcher_3DPhoto_SingleJpeg"
                            checked={
                                props.brokerFirmPlanSettings.roomSketcher_3DPhoto_SingleJpeg &&
                                props.brokerFirmPlanSettings.roomSketcherKey
                                    ? props.brokerFirmPlanSettings.roomSketcher_3DPhoto_SingleJpeg
                                    : false
                            }
                            disabled={!props.brokerFirmPlanSettings.roomSketcherKey}
                            onChange={props.onChange}
                        >
                            <span></span>
                        </Checkbox>
                    </Col>
                    <Col md={2}>
                        <Checkbox
                            name="brokerFirmPlanSettings.roomSketcher_3DPhoto_SingleLetterheadRelativeJpeg"
                            checked={
                                props.brokerFirmPlanSettings
                                    .roomSketcher_3DPhoto_SingleLetterheadRelativeJpeg &&
                                props.brokerFirmPlanSettings.roomSketcherKey
                                    ? props.brokerFirmPlanSettings
                                          .roomSketcher_3DPhoto_SingleLetterheadRelativeJpeg
                                    : false
                            }
                            disabled={!props.brokerFirmPlanSettings.roomSketcherKey}
                            onChange={props.onChange}
                        >
                            <span></span>
                        </Checkbox>
                    </Col>
                    <Col md={2}>
                        <Checkbox
                            name="brokerFirmPlanSettings.roomSketcher_3DPhoto_SingleLetterheadRelativePdf"
                            checked={
                                props.brokerFirmPlanSettings
                                    .roomSketcher_3DPhoto_SingleLetterheadRelativePdf &&
                                props.brokerFirmPlanSettings.roomSketcherKey
                                    ? props.brokerFirmPlanSettings
                                          .roomSketcher_3DPhoto_SingleLetterheadRelativePdf
                                    : false
                            }
                            disabled={!props.brokerFirmPlanSettings.roomSketcherKey}
                            onChange={props.onChange}
                        >
                            <span></span>
                        </Checkbox>
                    </Col>
                </Row>
            </fieldset>
            <Row>
                <Col md={6} className="no-label">
                    <FormGroup>
                        <Checkbox
                            name={
                                'brokerFirmPlanSettings.includeFreeFloorplansWithPhotoOrder'
                            }
                            checked={
                                !!props.brokerFirmPlanSettings
                                    .includeFreeFloorplansWithPhotoOrder
                            }
                            onChange={props.onChange}
                        >
                            <span>
                                {Translate('broker-firm/form/plan-settings/include-floorplans')}
                            </span>
                        </Checkbox>
                    </FormGroup>
                </Col>
            </Row>
        </fieldset>
    );
};

export default BrokerFirmPlanSettings;
